import { AirlineStopsOutlined, AppRegistration, HourglassEmpty } from '@mui/icons-material';
import { Bedtime, MoveToInbox } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import React, { useState } from 'react';

import DataGrid from '#app/Component/DataGrid';
import IconAction from '#app/Component/IconAction';
import DisabledPreparerModal from '#app/View/InventoryManagement/PreparerManager/components/DisabledPreparerModal';
import EditPreparerModal from '#app/View/InventoryManagement/PreparerManager/components/EditPreparerModal';
import useUserPreparers from '#app/View/InventoryManagement/PreparerManager/hooks/useUserPreparers';
import { CarrierCode, CarrierTranslation } from '#app/typings/carrier';
import { Channel, ChannelTranslations } from '#app/typings/channel';
import { UserPreparer } from '#app/typings/userPreparer';

const PreparerList: React.FC = () => {
  const classes = useStyles();
  const [currentPreparer, setCurrentPreparer] = useState<UserPreparer>();
  const [openDisabledPreparerModal, setOpenDisabledPreparerModal] = useState<boolean>(false);
  const [openEditPreparerModal, setOpenEditPreparerModal] = useState<boolean>(false);
  const { userPreparers, loading } = useUserPreparers();

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Nom',
      flex: 1,
    },
    {
      field: 'amount',
      headerName: 'Commande en simultanée',
      flex: 1,
    },
    {
      field: 'channel',
      headerName: 'Canal',
      valueGetter: (value: Channel) => ChannelTranslations[value],
      flex: 1,
      sortable: false,
    },
    {
      field: 'carriers',
      headerName: 'Transporteur',
      renderCell: ({ value }: GridRenderCellParams<any, CarrierCode[]>) => (
        <div>{value?.length ? value.map((item) => <div key={item}>{CarrierTranslation[item]}</div>) : '-'}</div>
      ),
      flex: 1,
      sortable: false,
    },
    {
      field: 'printerText',
      headerName: 'Imprimante',
      flex: 1,
    },
    {
      field: 'labelPrinterText',
      headerName: 'Imprimante à étiquette',
      flex: 1,
    },
    {
      field: 'orders',
      headerName: 'Commande en cours',
      renderCell: ({ value }: GridRenderCellParams<any, []>) => (
        <div>
          {value?.map((item) => (
            <div>{item}</div>
          ))}
        </div>
      ),
      flex: 1,
      minWidth: 210,
    },
    {
      field: 'isActive',
      headerName: 'Actif',
      width: 80,
      renderCell: ({ value, row }: GridRenderCellParams<UserPreparer, boolean>) =>
        !value ? (
          <Bedtime style={{ color: '#000000' }} />
        ) : row.orders.length === 0 ? (
          <HourglassEmpty style={{ color: '#17a2b8' }} />
        ) : (
          <MoveToInbox style={{ color: '#28a745' }} />
        ),
    },
    {
      field: 'action',
      headerName: 'Action',
      type: 'actions',
      width: 80,
      getActions: ({ row }) => [
        row.isActive ? (
          <IconAction
            title="Désactiver"
            className={classes.iconButton}
            onClick={() => {
              setOpenDisabledPreparerModal(true);
              setCurrentPreparer(row);
            }}
          >
            <AirlineStopsOutlined style={{ color: '#FFA07A' }} />
          </IconAction>
        ) : (
          <IconAction
            title="Modifier"
            className={classes.iconButton}
            onClick={() => {
              setOpenEditPreparerModal(true);
              setCurrentPreparer(row);
            }}
          >
            <AppRegistration style={{ color: '#FFA07A' }} />
          </IconAction>
        ),
      ],
    },
  ];

  return (
    <>
      <DataGrid
        sx={{
          '& .MuiDataGrid-cell': {
            fontSize: 11,
            py: 0.5,
            display: 'flex',
            alignItems: 'center',
          },
        }}
        getRowHeight={() => 'auto'}
        loading={loading}
        rows={userPreparers}
        columns={columns}
        hideFooter
        initialState={{
          sorting: { sortModel: [{ field: 'name', sort: 'asc' }] },
        }}
      />

      {openDisabledPreparerModal && currentPreparer && (
        <DisabledPreparerModal onClose={() => setOpenDisabledPreparerModal(false)} preparer={currentPreparer} />
      )}
      {openEditPreparerModal && currentPreparer && (
        <EditPreparerModal onClose={() => setOpenEditPreparerModal(false)} preparer={currentPreparer} />
      )}
    </>
  );
};

const useStyles = makeStyles({
  iconButton: {
    padding: '0!important',
  },
});

export default PreparerList;
